<template>
  <div>
    <div class="header">
      <header-tag :title="'修改绑定手机'"></header-tag>
    </div>
    <div
      class="form-body"
      v-show="showPhoneNext"
    >
      <div class="form-left">
        <p>通行证账号:</p>
        <p>验证方式:</p>
        <p v-if="show">绑定手机号:</p>
        <p v-if="show">短信验证码:</p>
        <p v-if="!show">微信二维码</p>
      </div>
      <div class="form-right">
        <p v-text="passportName"></p>
        <p>
          <input
            type="radio"
            value="使用手机验证"
            name="123"
            @click="show = true"
            checked
          />使用手机验证
          <input
            type="radio"
            value="使用微信验证"
            name="123"
            @click="wxCode"
            :disabled="!wxBind"
          />使用微信验证
        </p>
        <p
          v-if="show"
          v-text="phone"
        ></p>
        <p
          v-if="show"
          style="position: relative;"
        >
          <input
            type="text"
            placeholder="请输入验证码"
            v-model="form.oldSmsCode"
            @focus="resetFn"
          />
          <span
            v-show="showCode"
            @click="showImgCode"
          >获取验证码</span>
          <span v-show="!showCode">{{ count }} s</span>
        </p>
        <sliderUnlock
          ref="sliderUnlock"
          :l="50"
          :r="10"
          :w="260"
          :h="116"
          :block_y="block_y"
          :imgurl="imgurl"
          :miniimgurl="miniimgurl"
          @success="getResetNewCode"
        ></sliderUnlock>
        <div class="img-code">
          <imgCode
            ref="imgcodeOldPhone"
            @confirm="getResetCode"
          ></imgCode>
        </div>
        <div
          v-show="!show"
          id="wxImg2"
        ></div>
      </div>
    </div>
    <div
      class="form-body"
      v-show="!showPhoneNext"
    >
      <div class="form-left">
        <p>通行证账号:</p>
        <p>绑定手机号:</p>
        <p>短信验证码:</p>
      </div>
      <div class="form-right">
        <p v-text="passportName"></p>
        <p>
          <input
            class="next-code"
            type="text"
            placeholder="请输入新手机号"
            v-model="form.newPhone"
          />
        </p>
        <p style="position: relative;">
          <input
            class="next-code"
            type="text"
            placeholder="请输入验证码"
            v-model="form.newSmsCode"
            @focus="resetFn"
          />
          <span
            class="next-span"
            v-show="showCodeNext"
            @click="showImgCodeNext"
          >获取验证码</span>
          <span
            class="next-span"
            v-show="!showCodeNext"
          >{{ num }} s</span>
        </p>
        <div
          class="img-code"
          style="top:160px"
        >
          <imgCode
            ref="imgcodeNewPhone"
            @confirm="getResetNewCode"
          ></imgCode>
        </div>
      </div>
    </div>
    <div class="footer">
      <span
        v-text="wrongText"
        ref="phoneWrong"
      ></span>
      <button
        class="btn"
        @click="resetNewPhone"
        v-show="sure"
      >
        确定
      </button>
      <button
        class="btn"
        @click="resetOldPhone"
        v-show="next"
      >
        下一步
      </button>
      <button @click="closePhoneBind">取消</button>
    </div>
  </div>
</template>
<script>
import HeaderTag from "_c/tagTitle/headerTag";
import sliderUnlock from "../../login/sliderUnlock";
import { resetPhoneValidateOld } from "@/requests/safe";
import { resetPhone } from "@/requests/safe";
import { getResetPhoneNewSms } from "@/requests/safe";
import { getRestPhoneOldSms } from "@/requests/safe";
import { getDragImage } from "@/requests/user";

import { mapState } from "vuex";
import imgCode from "_sc/imgCode";
export default {
  name: "changePhone",
  components: {
    HeaderTag,
    imgCode,
    sliderUnlock
  },
  computed: {
    ...mapState({
      passportName: state => state.user.userInfo.passportName,
      phone: state => state.user.userInfo.phone,
      wxBind: state => state.user.userInfo.wxBind
    })
  },
  data() {
    return {
      count: "",
      showCode: true,
      showImg: false,
      showImgNext: false,
      show: true,
      timer: null,
      timerNext: null,
      showPwd: false,
      showPhoneNext: true,
      showCodeNext: true,
      num: "",
      c: true,
      sure: false,
      next: true,
      wrongText: "",
      form: {
        newSmsCode: "",
        oldSmsCode: "",
        newPhone: ""
      },
      imgurl: "",
      miniimgurl: "",
      block_y: 0,
    };
  },
  methods: {
    async getDragImage() {
      this.imgurl = "";
      this.miniimgurl = "";
      this.block_y = 0;
      let res = await getDragImage();
      if (res.code == 200) {
        this.imgurl = "data:image/png;base64," + res.data.bigImg;
        this.miniimgurl = "data:image/png;base64," + res.data.smallImg;
        this.block_y = Number(res.data.location_y);
        if (this.$refs.sliderUnlock) {
          this.$refs.sliderUnlock.reset(res.data.location_y);
        }
      } else {
        /* eslint-disable */
        console.log(res.msg);
      }
    },
    // 关闭手机绑定弹框
    resetFn() {
      this.wrongText = ''
    },
    closePhoneBind() {
      this.showPhone = false;
      this.next = true;
      this.sure = false;
      this.showPhoneNext = true;
      this.form.oldSmsCode = "";
      this.form.newSmsCode = "";
      this.form.newPhone = "";
      this.wrongText = '';
      this.$emit("showPhone", false);
    },
    //验证码倒计时
    countDown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    wxCode() {
      this.show = false;
      this.next = false;
      /* eslint-disable */
      var wxobj = new WxLogin({
        id: "wxImg2",
        appid: "wxebbc91ae550cfb80",
        scope: "snsapi_login",
        redirect_uri:
          "https://www.weihudashi.com/api/wx/resetPhoneValidateWx.htm",
        state: "https://www.weihudashi.com/home/accountSafe",
        style: "black",
        href: "https://www.weihudashi.com/css/weixin.css"
      });
    },
    showImgModals(data) {
      this.showImg = data;
    },
    showImgModalsNext(data) {
      this.showImgNext = data;
    },
    async resetOldPhone() {
      this.wrongText = "";
      let smsRe = this.$validateCenter.smsCode(this.form.oldSmsCode);
      if (smsRe.res == false) {
        this.wrongText = smsRe.msg;
        this.$domFn.shake(this.$refs.phoneWrong);
        return false;
      }
      let obj = {
        smsCode: this.form.oldSmsCode
      };
      let res = await resetPhoneValidateOld(obj);
      if (res.code == 200) {
        this.showPhoneNext = false;
        this.next = false;
        this.sure = true;
      } else {
        this.wrongText = res.msg;
        this.$domFn.shake(this.$refs.phoneWrong);
      }
    },
    async resetNewPhone() {
      this.wrongText = "";
      let phoneRe = this.$validateCenter.phoneNum(this.form.newPhone);
      if (phoneRe.res == false) {
        this.wrongText = phoneRe.msg;
        this.$domFn.shake(this.$refs.phoneWrong);
        return false;
      }
      let smsRe = this.$validateCenter.smsCode(this.form.newSmsCode);
      if (smsRe.res == false) {
        this.wrongText = smsRe.msg;
        this.$domFn.shake(this.$refs.phoneWrong);
        return false;
      }
      let obj = {
        newPhone: this.form.newPhone,
        smsCode: this.form.newSmsCode
      };
      let res = await resetPhone(obj);
      if (res.code == 200) {
        this.$emit("showPhone", false);
        this.next = true;
        window.location.href = 'https://www.weihudashi.com/v2/home/accountSafe'
      } else {
        this.wrongText = res.msg;
        this.$domFn.shake(this.$refs.phoneWrong);
      }
    },
    //验证码倒计时
    countDownNext() {
      const TIME_COUNT = 60;
      if (!this.timerNext) {
        this.num = TIME_COUNT;
        this.showCodeNext = false;
        this.timerNext = setInterval(() => {
          if (this.num > 0 && this.num <= TIME_COUNT) {
            this.num--;
          } else {
            this.showCodeNext = true;
            clearInterval(this.timerNext);
            this.timerNext = null;
          }
        }, 1000);
      }
    },
    urlCode() {
      if (this.$route.query.isBindWx == "1") {
        this.$emit("showPhone", true);
        this.showPhoneNext = false;
        this.next = false;
        this.sure = true
      }
      if (this.$route.query.isBindWx == "0") {
        window.$Message.show({
          title: "提示",
          type: "error",
          msg: decodeURIComponent(this.$route.query.msg)
        });
      }
    },
    showImgCode() {
      this.$refs.imgcodeOldPhone.show();
      // this.getDragImage();
      // this.$refs.sliderUnlock.slideShow = true;
    },
    showImgCodeNext() {
      let re = this.$validateCenter.phoneNum(this.form.newPhone);
      if (re.res == false) {
        this.wrongText = re.msg;
        this.$domFn.shake(this.$refs.phoneWrong);
        return false;
      }
      this.$refs.imgcodeNewPhone.show();
    },
    async getResetCode(code) {
      let re = this.$validateCenter.imgCode(code);
      if (re.res == false) {
        this.wrongText = re.msg;
        return false;
      }
      let obj = {
        imgCode: code
      };
      let res = await getRestPhoneOldSms(obj);
      if (res.code == 200) {
        this.countDown();
        this.$refs.imgcodeOldPhone.hide();
      } else {
        this.wrongText = res.msg;
      }
    },
    async getResetNewCode(code) {
      let re = this.$validateCenter.imgCode(code);
      if (re.res == false) {
        this.wrongText = re.msg;
        return false;
      }
      let obj = {
        newPhone: this.form.newPhone,
        imgCode: code
      };
      let res = await getResetPhoneNewSms(obj);
      if (res.code == 200) {
        this.countDownNext();
        this.$refs.imgcodeNewPhone.hide();
      } else {
        this.wrongText = res.msg;
      }
    }
  },
  mounted() {
    // this.wxCode()
    this.urlCode();
  }
};
</script>
<style lang="scss" scoped>
.img-code {
  .modals {
    .reload {
      top: 24px !important;
    }
    input {
      width: 90px !important;
    }
    button span {
      background-position: 10px 8px;
    }
  }
}
.form-body {
  overflow: hidden;
  width: 100%;
  padding: 10px 0px 20px 0px;
  .form-left {
    float: left;
    width: 150px;
    text-align: right;
    font-size: 14px;
    color: rgb(161, 161, 161);
    line-height: 40px;
  }
  .form-right {
    float: left;
    padding-left: 15px;
    width: 300px;
    text-align: left;
    line-height: 40px;
    // background-color: #0ff;
    p {
      height: 40px;
    }
    p:nth-child(4) input {
      width: 100%;
      height: 30px;
      padding-left: 10px;
      border: 1px solid #d9dee4;
    }
    p:nth-child(4) span {
      position: absolute;
      top: 0px;
      right: 0px;
      // transform: translate(240px,-40px);
      color: rgb(0, 102, 204);
      cursor: pointer;
    }
    input {
      vertical-align: middle;
    }
  }
  .img-code {
    position: absolute;
    top: 200px;
    right: 90px;
    width: 140px;
    height: 55px;
  }
}
.header {
  padding-left: 30px;
  text-align: left;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #d9dee4;
}
.footer {
  margin-top: 20px;
  padding: 20px 0;
  margin-left: 5%;
  width: 90%;
  text-align: right;
  border-top: 1px solid #d9dee4;
  button {
    width: 100px;
    line-height: 30px;
  }
  .btn {
    background-color: rgb(0, 153, 204);
    border: 1px solid rgb(0, 153, 204);
    color: #fff;
  }
  button:last-child {
    margin-left: 10px;
    background-color: rgb(247, 247, 247);
    border: 1px solid #d9dee4;
  }
  span {
    float: left;
    padding-left: 50px;
    line-height: 30px;
    color: #f00;
  }
}
.next-code {
  width: 100%;
  height: 30px;
  // line-height: 20px;
  padding-left: 10px;
  border: 1px solid #d9dee4;
}
.next-span {
  position: absolute;
  top: 0px;
  right: 0px;
  // transform: translate(240px,-40px);
  color: rgb(0, 102, 204);
  cursor: pointer;
}
.mask_layer_model {
  top: 0 !important;
}
</style>
